// @flow
import { keys, pickBy } from 'lodash';
import dayjs from 'dayjs';
import type {
  BusinessSetting,
  BusinessSettingForm,
} from '../business_settings/BusinessSetting';
import type { OpeningBalance } from '../opening_balances/OpeningBalance';

export const purpose = {
  businessPlan: 0,
  capitalPolicy: 1,
  capitalIncrease: 2,
  stockholderMeeting: 3,
  stockholders: 4,
  ir: 5,
  meetCapital: 6,
  downloadDocument: 7,
  watchVideo: 8,
  manageInvestments: 9,
  other: 10,
};

export type Company = {
  companyName: string,
  representativeName: string,
  companySize: number,
  businessFields: Array<number>,
  hqAddress: string,
  establishedAt: string,
  businessStartAt: string,
  phoneNumber: string,
  website: string,
  logo: File | string,
  updatedAt: string,
  businessSetting: BusinessSetting,
  openingBalance: ?OpeningBalance,
};

export type CompanyForm = {
  businessStartAt?: string,
  businessSetting?: BusinessSettingForm,
  establishAt?: Date,
};

export const defaultValues = {
  companyName: '',
  representativeName: '',
  companySize: -1,
  businessFields: [],
  hqAddress: '',
  establishedAt: '',
  businessStartAt: '',
  phoneNumber: '',
  website: '',
  logo: null,
  updatedAt: '',
};

export function businessStartYears(): Array<any> {
  const years = [];
  const thisYear = dayjs().year();
  const startYear = thisYear - 50;

  for (let i = startYear; i <= thisYear; i++) {
    years.push({
      value: i,
      label: `${i}`,
    });
  }

  return years;
}

export const businessStartMonths: Array<any> = [
  { value: 1, label: '1月' },
  { value: 2, label: '2月' },
  { value: 3, label: '3月' },
  { value: 4, label: '4月' },
  { value: 5, label: '5月' },
  { value: 6, label: '6月' },
  { value: 7, label: '7月' },
  { value: 8, label: '8月' },
  { value: 9, label: '9月' },
  { value: 10, label: '10月' },
  { value: 11, label: '11月' },
  { value: 12, label: '12月' },
];

export const filterValues = (values: Object) => {
  const allowedKeys = keys(defaultValues);
  return pickBy(values, (v, k) => allowedKeys.includes(k));
};
